import { Config } from "./constant";
import {
  AgentCareStore,
  ClearTypingTimestamp,
  AddMessageToStore,
  UnsetCustomer,
  SetSessionIsNotActive,
  SetSessionIsActive,
  SetHasPendingMessage,
  SetHasNoPendingMessage,
  SetChatRoomId,
  UnsetChatRoomId,
  ResetMessageStore,
  UpdateCaptchaResponse,
  GetFirstMessage,
  ResetInitRoom,
  IsSessionTimeout,
  SetTypingTimestamp,
  IsAllowCreateSession,
  DisableCreateSession,
  IsSessionActive,
  SaveAssignedAgent,
  ResetAssignedAgent,
  IncrementSessionTimeoutCount,
  IsMaxTimeoutCountReached,
  ResetSessionTimeoutCount,
  CommonStore,
  LocalStorage,
  SetCustomer,
  GetCustomer,
  LoadHistoryAfterLoad,
  MarkHistoryAsLoaded,
  GetIdPel,
  GetActiveEntryPointId,
  GetNextHistory,
  SetNextHistory,
  GetHistoryHasNext,
  SetHistoryHasNext,
} from "./Store";
import {
  ConnectionInitiated,
  AgentRepliesText,
  ChatRoomInitiated,
  MessageCreated,
  SystemClosedTheChat,
  parse,
  ValidateStaleConversationIdResult,
  MessageWithMediaCreated,
  AgentRepliesMedia,
  SendMediaError,
  CaptchaChallengeAnswerError,
  AgentIsAssignedToChat,
  CustomerSeemsInactive,
  CustomerClosesTheChatDueToInactivity,
} from "./model/Incoming";
import {
  CustomerSendsMediaType,
  CustomerSendsText,
  CustomerSendsTextType,
  ValidateStaleConversationId,
} from "./model/Outgoing";
import Axios from "axios";

let message = [];
let messageBacklog = [];
let isConnectionOpen = false;
let socketRef = null;

let sessionId = null;
let timeoutIdForInit = null;
function resetSession() {
  clearInterval(sessionId);
  ClearTypingTimestamp();
  ResetAssignedAgent();
  UnsetCustomer();
  ResetMessageStore();
}

export async function loadHistory() {
  const next = GetNextHistory();
  const hasNext = GetHistoryHasNext();
  if (hasNext) {
    const endpoint =
      Config.chatHistoryUrl +
      "?id=" +
      LocalStorage.get("chatRoomId") +
      (next ? "&next=" + next : "");
    try {
      const result = await Axios.get(endpoint);
      if (result.data) {
        const { list, paging } = result.data;
        console.log("Paging", paging);
        if (paging && paging.cursor && paging.cursor.next) {
          SetNextHistory(paging.cursor.next);
        } else {
          console.log("No history left");
          SetNextHistory(null);
          SetHistoryHasNext(false);
        }
        list.reverse().forEach((element) => {
          AddMessageToStore(parse(element));
        });
      }
    } catch (e) {}
  }
}

function startSession() {
  console.log("Begin checking!");
  // sessionId = setInterval(() => {
  //   console.log("Check!")
  //   let isTimedOut = IsSessionTimeout()
  //   console.log('timeout count',CommonStore.sessionTimeoutCount)
  //   console.log('Is timeout',isTimedOut)
  //   if(isTimedOut) {
  //     console.log('timeout count',CommonStore.sessionTimeoutCount)
  //     IncrementSessionTimeoutCount()
  //     if(IsMaxTimeoutCountReached(2)) {
  //       sendWithSession(CustomerSendsText("Customer appears to be inactive and will be logged off from chat."))
  //       unsetChatRoomId()
  //       resetSession()
  //     } else {
  //       let messageFromAgent = {
  //         messageId: new Date().getTime(),
  //         text: 'Hi, are you still there? You will be disconnected from chat if you don\'t have anything else to add.',
  //         isSystem: true
  //       };
  //       AddMessageToStore(messageFromAgent)
  //     }
  //   } else {
  //     // ResetSessionTimeoutCount()
  //   }
  // }, 1000 * 30)
}

async function logAgentRequest(customer) {
  const logUri = Config.agentRequestLogUri;

  const result = await Axios.post(logUri, {
    entryPoint: GetActiveEntryPointId(),
    connectionId: getConnectionId(),
    name: customer.name,
    email: customer.email,
    idPel: GetIdPel(),
    phoneNumber: customer.phoneNumber,
    conversationId: getChatRoomId(),
  });
}

export function StartTimerForTimeout(triggerAt) {
  console.log("Check init timeout!");
  const isAllow = IsAllowCreateSession();
  const isSessionActive = IsSessionActive();
  if (isAllow && !isSessionActive) {
    let repeat = false;
    if (triggerAt) {
      const delta = new Date().getTime() - triggerAt;
      if (delta < 120000) {
        repeat = true;
      } else {
        DisableCreateSession(
          "Agent seems to be busy. Please wait a bit longer"
        );
        ResetInitRoom();
      }
    } else {
      repeat = true;
    }
    console.log("Will repeat check..");
    if (repeat) {
      timeoutIdForInit = setTimeout(
        () =>
          StartTimerForTimeout(triggerAt ? triggerAt : new Date().getTime()),
        10000
      );
    }
  } else {
  }
}

function initConnection(onMessage, onOpen, onClose) {
  let Resolver;
  let Rejecter;
  const promise = new Promise((resolve, reject) => {
    Resolver = resolve;
    Rejecter = reject;
  });
  const socket = new WebSocket(Config.websocketUrl);
  socket.addEventListener("open", (e) => {
    isConnectionOpen = true;
    onOpen(socket);
    Resolver();
  });
  socket.addEventListener("close", (e) => {
    isConnectionOpen = false;
    onClose();
  });

  socket.addEventListener("message", (newMessage) => {
    Resolver();
    onMessage(newMessage);
  });

  return promise.then(() => socket);
}

export function getConnectionId() {
  return LocalStorage.get("connectionId");
}

export function getChatRoomId() {
  return LocalStorage.get("chatRoomId");
}

function unsetChatRoomId() {
  UnsetChatRoomId();
  LocalStorage.remove("chatRoomId");
}

export function checkIsConnectionOpen() {
  return isConnectionOpen;
}

function startSocketCore() {
  initConnection(
    (newMessage) => {
      let messageFromJs = JSON.parse(newMessage.data);
      const parsed = parse(messageFromJs);
      const { type } = parsed;
      if (type === ConnectionInitiated) {
        console.log("Initiated!");
        LocalStorage.set("connectionId", messageFromJs.connectionId);
        const chatRoomId = getChatRoomId();
        if (chatRoomId) {
          SetTypingTimestamp();
          sendWithSession(ValidateStaleConversationId(getChatRoomId()));
        }
      } else if (type === MessageCreated) {
        let messageFromCustomer = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
        };
        message.push(messageFromCustomer);
        SetHasNoPendingMessage();
        AddMessageToStore(messageFromCustomer);
      } else if (type === AgentRepliesText) {
        let messageFromAgent = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
          agentName: parsed.agentName,
        };
        message.push(messageFromAgent);
        AddMessageToStore(messageFromAgent);
      } else if (type === ChatRoomInitiated) {
        if (IsAllowCreateSession()) {
          MarkHistoryAsLoaded();
          clearTimeout(timeoutIdForInit);
          ResetInitRoom();
          const chatRoomId = parsed.chatRoomId;

          SetCustomer(parsed.customer);
          SetSessionIsActive();
          SetChatRoomId(chatRoomId);
          startSession();
          const firstMessage = GetFirstMessage();
          if (firstMessage) {
            sendWithSession(CustomerSendsText(firstMessage));
            SetTypingTimestamp();
          }
          logAgentRequest(parsed.customer);
        } else {
          console.log("Reincarnated message detected!", parsed);
        }
      } else if (type === ValidateStaleConversationIdResult) {
        if (!(parsed.isValid && parsed.conversationId == getChatRoomId())) {
          unsetChatRoomId();
          SetSessionIsNotActive();
          resetSession();
        } else {
          console.log("Is active!");
          SetSessionIsActive();
          SetChatRoomId(parsed.conversationId);
          SaveAssignedAgent(parsed.assignedAgent);
          SetCustomer(parsed.customer);
          LoadHistoryAfterLoad();
          if (!sessionId) startSession();
        }
      } else if (type === SystemClosedTheChat) {
        unsetChatRoomId();

        // SetSessionIsNotActive()
        resetSession();
      } else if (type == MessageWithMediaCreated) {
        let messageFromCustomer = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
          mediaList: parsed.mediaList,
        };
        message.push(messageFromCustomer);
        SetHasNoPendingMessage();
        AddMessageToStore(messageFromCustomer);
      } else if (type === AgentRepliesMedia) {
        let messageFromAgent = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
          agentName: parsed.agentName,
          mediaList: parsed.mediaList,
        };
        message.push(messageFromAgent);
        AddMessageToStore(messageFromAgent);
      } else if (type == SendMediaError) {
        let messageFromSystem = {
          content: parsed.content,
          type: parsed.type,
          mediaList: parsed.mediaList,
          fromSystem: true,
        };
        SetHasNoPendingMessage();
        AddMessageToStore(messageFromSystem);
      } else if (type == CaptchaChallengeAnswerError) {
        UpdateCaptchaResponse(parsed.message);
        ResetInitRoom();
      } else if (type == AgentIsAssignedToChat) {
        SaveAssignedAgent(parsed.agentName || "System");
      } else if (type == CustomerSeemsInactive) {
        const customer = GetCustomer();
        let text = parsed.text;
        if (customer) {
          text = text.replace("{customerName}", customer.name);
        }
        let messageFromAgent = {
          messageId: new Date().getTime(),
          text: text,
          isSystem: true,
        };
        AddMessageToStore(messageFromAgent);
      } else if (type == CustomerClosesTheChatDueToInactivity) {
        let messageFromAgent = {
          messageId: new Date().getTime(),
          text: parsed.text,
          isSystem: true,
        };
        AddMessageToStore(messageFromAgent);
        unsetChatRoomId();
        resetSession();
      }
    },
    (socket) => {
      console.log("Connection is opened!");
      socketRef = socket;
      messageBacklog.forEach((item) => send(item));
      messageBacklog = [];
    },
    () => {
      socketRef = null;
      console.log("Connection is closed! Waiting to reconnect..");
      setTimeout(() => startSocketCore(), 300);
    }
  );
}

export let send = (data) => {
  if (isConnectionOpen) {
    console.log("Sending message", data);
    socketRef.send(data, function (err) {
      if (err) {
        console.log("ERR", err);
      }
    });
  } else {
    messageBacklog.push(data);
  }
};

export const sendWithSession = (data) => {
  const payload = {
    connectionId: getConnectionId(),
    message: data,
  };
  const { _type } = data;
  if (_type == CustomerSendsTextType || _type == CustomerSendsMediaType) {
    SetHasPendingMessage();
  }
  return send(JSON.stringify(payload));
};

export function getMessage() {
  return message;
}

export let closeConnection = () => {
  if (isConnectionOpen && socketRef) {
    socketRef.close();
  }
};
startSocketCore();
